export const getUserProfileQueryKey = () => ["userProfile"];
